<template>
  <div id="biz">
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  import 'bootstrap'
  import 'common/libs/kendo-ui/css/web/kendo.common.min.css'
  import 'common/libs/kendo-ui/css/web/kendo.haezoom.css'
  import 'common/libs/kendo-ui/js/kendo.all.min.js'
  import 'common/libs/kendo-ui/js/messages/kendo.messages.ko-KR.min.js'
  import 'common/libs/kendo-ui/js/cultures/kendo.culture.ko-KR.js'
  import 'common/libs/bootstrap/dist/css/bootstrap.css'
  import 'common/assets/css/style.scss'
  import '@/assets/css/global.scss'
  import 'c3/c3.min.css'
  import { mapActions } from 'vuex'

  export default {
    name: 'app',
    data () {
      return {
        title: 'BIZ Haezoom'
      }
    },
    methods: {
      ...mapActions([
        'getMenuList',
        'getRecentInputPrice'
      ]),
      tryLogin (data) {
        // 토큰발급
        this.$store.dispatch('getToken', data).then((response) => {
          this.getUserInfo(response.token)
          this.getUserCondition()
        }).catch(error => {
          this.error = true
          console.log('Login Fail!', error)
        })
      },
      getUserInfo (token) {
        // 사용자 정보 요청 API
        this.$store.dispatch('getUserInfo', token).then((response) => {
          // 비인증 사용자의 경우, 알림을 띄운다.
          if (response.result.auth_level === '0') {
            alert(response.detail)
            this.$router.push('/mypage')
          }
        }).catch(error => {
          // 유효하지 않은 토큰일 경우 로그아웃 처리한다.
          this.$store.commit('LOGOUT')
          console.log('get UserInfo Error!', error)
        })
      },
      getUserCondition () {
        // 기본 수익조건을 불러온다.
        this.$store.dispatch('getUserCondition').catch(error => {
          this.error = true
          console.log('getUserCondition error!', error)
        })
      }
    },
    created: function () {
      const token = localStorage.getItem('_t')

      if (token) {
        // 토큰이 있을 경우 유효성을 검증한다.
        this.$store.dispatch('inspectToken', token).then(() => {
          // 유효한 토큰이면 사용자 정보와 기본 수익조건을 불러온다.
          this.getUserInfo(token)
          this.getUserCondition(token)
        })
      }

      // 기본 메뉴 목록 불러오기
      this.getMenuList()

      // 최근 입력한 SMP, REC 가격 불러오기
      this.getRecentInputPrice()
    }
  }
</script>

<style lang="scss">
  * {font-family: "Spoqa Han Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;}

  html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  #biz {
    font-size: 14px;
    line-height: 1.29;
    letter-spacing: -0.3px;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #495057;
    height: 100%;
  }

  /* input type number 에서 화살표 제거 */
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }


  h1, h2, h3, h4, h5, h6 {
    color: $header-color;
  }

  .h1, .h2, .h3, .h4, .h5, .h6 {
    &.normal {
      font-weight: normal;
    }
  }

  .h1, h1 {
    font-size: $h1-font-size;
  }

  .h2, h2 {
    font-size: $h2-font-size;
  }

  .h3, h3 {
    font-size: $h3-font-size;
  }

  .h4, h4 {
    font-size: $h4-font-size;
    line-height: 1.2;
  }

  .h5, h5 {
    font-size: $h5-font-size;
  }

  .h6, h6 {
    font-size: $h6-font-size;
  }

  .k-radio-label:before {
    width: 16px !important;
    height: 16px !important;
  }

  .k-radio:checked+.k-radio-label:before {
    border-color: #f76707;
  }

  .btn {
    padding: 9px 12px;
  }

  .clickable {
    cursor: pointer
  }

  .form-horizontal .control-label {
    padding-top: 7px;
  }

  .subtab-page {
    background: $grey;
    padding-top: 64px;

    &.full-screen {
      > .tab {
        -webkit-transform: translateY(-64px);
        -ms-transform: translateY(-64px);
        transform: translateY(-64px);
      }
    }

    > .tab {
      background: #FFF;
      height: 48px;
      border-bottom: 1px solid $border-color;
      position: fixed;
      width: 100%;
      z-index: 2;

      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      will-change: transform;
      -webkit-transition: -webkit-transform .5s;
      transition: -webkit-transform .5s;
      transition: transform .5s;
      transition: transform .5s, -webkit-transform .5s;

      .nav {
        width: 430px;
        margin: 0 auto;

        &.align-left {
          margin: 0 0 0 24px;
        }
      }
    }

    .nav .back {
      height: 40px;
      padding: 11px 0;
      margin: 64px 0 16px;
    }
  }

  .explain-text {
    font-size: 12px;
    color: #1098ad;
  }

  .require-tag {
    font-size: 12px;
    color: $primary-color;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue